<template>
  <div id="checkin" class="container">
    <div class="check-tab">
      <CheckInTab :tabInit="tabInit"></CheckInTab>
    </div>
    <div class="checkin-wrap">
      <div class="check-step-outer">
        <div class="checkin-step clearfix">
          <step :steps="steps" :current="currentStep" />
        </div>
      </div>
      <div class="step-wrap">
        <components
          v-bind:is="stepName"
          :stepData="stepData"
          :pageData="pageData"
          :cmsData="cmsData"
          @callback="nextStep"
        ></components>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
#checkin {
  .checkin-wrap {
    padding-top: 30px;
  }
  .checkin-step {
    margin: 0 auto;
  }
  .step-wrap {
    padding-top: 50px;
  }
}
@media only screen and (max-width: 768px) {
  #checkin {
    .check-step-outer {
      width: 100%;
      overflow-x: scroll;
    }
  }
}
</style>
<script>
import CheckInTab from '@/components/checkin/checkInTab'
import Step1 from './components/step1'
import Step2 from './components/step2'
import Step3 from './components/step3'
import Step4 from './components/step4'
import './index'

export default {
  data () {
    return {
      tabInit: '1',
      idInfo: {},
      currentStep: 1,
      steps: ['身份验证', '选择行程', '选择座位', '打印登机牌'],
      stepName: 'step1',
      stepData: {},
      pageData: {},
      tourIndex: 0,
      cmsData: {}
    }
  },
  created () {
    this.getCmsData()
    window.__MICRO_ROOT__?.api?.track?.('checkin_view')
  },
  methods: {
    async getCmsData () {
      try {
        await window.__MICRO_ROOT__?.cms?.getPageData().then(res => {
          this.cmsData = res
        })
      } catch (err) {}
    },
    nextStep (step, data, pageData) {
      this.currentStep = step
      this.stepName = 'step' + step
      if (data) {
        this.stepData = data
      }
      if (pageData) {
        this.pageData = Object.assign(this.pageData, pageData)
      }
    }
  },
  components: {
    CheckInTab,
    Step1,
    Step2,
    Step3,
    Step4
  }
}
</script>
